import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { useAuth } from '../components/AuthContext';
import { useUserStoreActions } from './useUser';

/**
 * Custom hook to handle user logout
 * Encapsulates logout logic and cleanup
 */
export const useLogout = () => {
  const navigate = useNavigate();
  const { setIsLogged } = useAuth();
  const { clearUser } = useUserStoreActions();

  const logout = useCallback(async (): Promise<void> => {
    try {
      await api.post('/auth/logout');
      
      // Clear auth state and user data
      setIsLogged(false);
      clearUser();
      
      // Navigate to login
      navigate('/login');
    } catch (err) {
      console.error('Logout failed:', err);
      
      // Even if API call fails, clear local state
      // httpOnly cookies are managed by the browser/server
      setIsLogged(false);
      clearUser();
      navigate('/login');
    }
  }, [navigate, setIsLogged, clearUser]);

  return { logout };
};
